/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWorkspacePremiumIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-workspace-premium"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 11.85L10.1 13.32Q9.9 13.47 9.71 13.34Q9.53 13.2 9.6 12.97L10.3 10.55L8.4 9.2Q8.2 9.07 8.28 8.84Q8.35 8.6 8.6 8.6L10.95 8.6L11.68 6.13Q11.75 5.88 12 5.88Q12.25 5.88 12.32 6.13L13.05 8.6L15.4 8.6Q15.65 8.6 15.72 8.84Q15.8 9.07 15.6 9.2L13.7 10.55L14.4 12.97Q14.47 13.2 14.29 13.34Q14.1 13.47 13.9 13.32ZM12 21.55L7 23.27Q6.35 23.5 5.8 23.1Q5.25 22.7 5.25 22.02L5.25 15.35Q4.28 14.18 3.76 12.74Q3.25 11.3 3.25 9.75Q3.25 6.1 5.8 3.55Q8.35 1 12 1Q15.65 1 18.2 3.55Q20.75 6.1 20.75 9.75Q20.75 11.3 20.26 12.74Q19.77 14.18 18.75 15.35L18.75 22.02Q18.75 22.7 18.2 23.1Q17.65 23.5 17 23.27ZM12 15.85Q12 15.85 13.28 15.85Q14.55 15.85 16.32 14.07Q18.1 12.3 18.1 9.75Q18.1 7.2 16.32 5.42Q14.55 3.65 12 3.65Q9.45 3.65 7.67 5.42Q5.9 7.2 5.9 9.75Q5.9 12.3 7.67 14.07Q9.45 15.85 12 15.85Z" fill={color} />
    </svg>
  );
}
